import { FC } from "react";
import classNames from "classnames";

import { AppliaRoute } from "../../config/routes/routes";
import { Breadcrumb } from "../../components/Breadcrumb/Breadcrumb";
import { Container } from "../../components/Container/Container";
import { ContentBuilder } from "../../components/ContentBuilder/ContentBuilder";
import { ContentFooter } from "../../components/ContentFooter/ContentFooter";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import { PillarTopics } from "../../components/PillarTopics/PillarTopics";
import { Seo } from "../../components/Seo/Seo";
import { usePageContent } from "../../hooks/content/usePageContent";
import { useRouteInfo } from "../../hooks/route/useRouteInfo";

const Pillar: FC = () => {
	const { routeData, title, description } = useRouteInfo();
	const { blocks, heroImage, heroIntro, pageIntro } = usePageContent();

	return (
		<>
			<Seo
				title={title}
				description={typeof description === "string" && description.trim().length > 0 ? description : undefined}
			/>

			<article className="break-words relative">
				<div className="absolute top-3 left-0 w-full z-10 px-6 md:px-9 xl:px-14 py-3">
					<Breadcrumb
						className="text-white"
						items={[
							{ label: "Home", to: "/", className: "text-white" },
							{ label: routeData?.label ?? "" },
						]}
					/>
				</div>

				{/* Page header mobile */}
				<div className="block md:hidden">
					<PageHeader
						backgroundImage={heroImage}
						containerClassName="!pt-20"
						contentClassName="!mx-0"
						title={
							<>
								<p className="uppercase text-white text-sm">
									Pillar {(routeData as AppliaRoute)?.pillarNumber}
								</p>
								<h1 className="text-4xl text-white font-semibold">{routeData?.label ?? ""}</h1>
							</>
						}
						{...(!!heroIntro && {
							intro: heroIntro,
						})}
					/>
				</div>

				{/* Page header desktop */}
				<div className="hidden md:block">
					<PageHeader
						backgroundImage={heroImage}
						containerClassName="!pt-24"
						contentClassName="!mx-0"
						title={
							<h1 className={classNames("text-3xl xl:text-5xl", { "text-white": !!heroImage })}>
								<span className="block text-sm uppercase font-light tracking-widest mb-2">
									Pillar {(routeData as AppliaRoute)?.pillarNumber}
								</span>
								{routeData?.label ?? ""}
							</h1>
						}
						{...(!!heroIntro && {
							intro: heroIntro,
						})}
					/>
				</div>
				<Container contentClassName="!py-0">
					<div className={classNames("max-w-6xl", { "pt-14": typeof pageIntro !== "undefined" })}>
						{(routeData as AppliaRoute)?.children && (
							<PillarTopics
								children={(routeData as AppliaRoute).children!}
								pillarUrl={routeData?.url ?? ""}
							/>
						)}
						{typeof pageIntro !== "undefined" ? <p className="text-xl leading-relaxed">{pageIntro}</p> : null}
						<ContentBuilder blocks={blocks} />
						<ContentFooter />
					</div>
				</Container>
			</article>
		</>
	);
};

export { Pillar };
